module.exports = __webpack_public_path__ + "static/media/cases_ident_visual_bd_04.9c72b7a1.jpg";